// extracted by mini-css-extract-plugin
export default {"element":"PlaceCard_element__m0ElP"};